// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"137b6eb2","498":"132897f1","545":"49c0d666"}[chunkId] + ".chunk.js";
};